import { JourneyField as Field, JourneySelect as Select } from "../../controls";
import { UK_STATUS_OPTIONS } from "../../options";

export const UkStatusStep = ({ answers, update }) => (
  <div>
    <h2 className="font-display text-3xl font-bold tracking-tight text-ink">What is your UK status?</h2>
    <p className="mt-2 text-sm leading-6 text-slatey">Your funding route makes this relevant. Self-declaration only — official verification happens later, and only if required. No share code is requested here.</p>
    <div className="mt-6 max-w-xl">
      <Field label="Current UK status"><Select value={answers.uk_status} onChange={(v) => update("uk_status", v)} testId="journey-uk-status" placeholder="Select your status" options={UK_STATUS_OPTIONS} /></Field>
    </div>
  </div>
);
